/* eslint-disable @typescript-eslint/naming-convention */
import { DecelerationLimit } from 'src/api';

export const decelerationConfig: DecelerationLimit = {
  config_type: DecelerationLimit.config_type.DECELERATION_LIMIT,
};
